import config from 'app/config';
import request from 'superagent';

export default (showUrl, episodeUrl) => {
  return new Promise((resolve, reject) => {
    try {
      request.get(`${config.get('SHORT_HOST')}/api/v1/${showUrl}/${episodeUrl}`).end((err, res) => {
        if (err) {
          reject(err);
        } else if (res.body && res.body.data && res.body.data.hash) {
          resolve(`${config.get('SHORT_HOST')}/${res.body.data.hash}`);
        } else {
          reject('Invalid response');
        }
      });
    } catch (e) {
      reject(e);
    }
  });
};
